<template>
  <div class="checklist__item" :class="editClass">
    <!-- item control -->
    <ChecklistsChecklistItemControl
      :disabled="disabled"
      :item="item"
      @status-changed="updateValues"
    />
    <!-- item heading -->
    <ChecklistsChecklistItemHeading
      :item="item"
      :changes-saved="apiCallSucceed"
      @save-changes="updateValues"
    />
  </div>
</template>

<script>
// Utitilities
import ChecklistsMixin from '../mixins'
// Components
import ChecklistsChecklistItemControl from './ChecklistsChecklistItemControl'
import ChecklistsChecklistItemHeading from './ChecklistsChecklistItemHeading'

export default {
  name: 'ChecklistsChecklistItem',

  components: {
    ChecklistsChecklistItemHeading,
    ChecklistsChecklistItemControl,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },

    disabled: {
      type: Boolean,
      required: true,
    },
  },

  mixins: [ChecklistsMixin],

  methods: {
    async updateValues(itemInfo) {
      const update = await this.$store.dispatch('checklists/updateItem', itemInfo)

      if (!this.checkApiResponse(update)) return
      this.changeSavedToggle()
    },
  },
  computed: {
    editClass() {
      return this.isEditPage && 'checklist__item--editing'
    },
  },
}
</script>

<style scoped>
/* basics */
.checklist__item {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: flex-start;
  position: relative;
  font-size: 14px;
  padding: 5px 0;
  border-radius: 2px;
  user-select: none;
}

/* template items */
.template .checklist__item {
  margin-bottom: 10px;
  padding: 5px 10px;
  border: 1px solid var(--c-secondary-400);
  border-radius: 4px;
  /* box-shadow: 0 0 8px -4px var(--rgba-default); */
}

.template .checklist__item--editing {
  grid-template-columns: 20px 1fr;
}
/* end template style */
</style>
